'use client';

import './CookieSettingsButton.css';

import { Button } from 'react-bootstrap';
import { useCookieConsent } from './CookieConsentContext';

function CookieSettingsButton({ children }) {
  const { openSettings, settings } = useCookieConsent();
  
  return (
    <Button
      className="cookie-settings-button"
      onClick={(e) => {
        e.preventDefault(); // Prevent default link behavior if Button acts as a link
        openSettings();
      }}
    >
      {children}
    </Button>
  );
}

export default CookieSettingsButton;